import React from 'react';

import PropTypes from 'prop-types';

import { useIsCurrentUserGalleryAccessLimited } from './helpers/hooks';
import PhotoGalleryAccessLimitedEmptyState from './PhotoGalleryAccessLimitedEmptyState';
import EntityPickerModalListContent from '../../modal/EntityPickerModalListContent';

const PhotoCustomDataView = ({ isPluginDisabledInEntitlements, ...props }) => {
  const isCurrentUserGalleryAccessLimited =
    useIsCurrentUserGalleryAccessLimited();

  if (isCurrentUserGalleryAccessLimited || isPluginDisabledInEntitlements) {
    return (
      <PhotoGalleryAccessLimitedEmptyState
        hideDescription={isPluginDisabledInEntitlements}
      />
    );
  }

  return <EntityPickerModalListContent {...props} />;
};

PhotoCustomDataView.propTypes = {
  isPluginDisabledInEntitlements: PropTypes.bool,
};

export default PhotoCustomDataView;
